import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Fuse from 'fuse.js';

//import ClusterMarker from './ClusterMarker';
import {
  getSegments,
  getOptions,
  changeMode,
} from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';
import constants, { ViewMode } from '../../constants';
import ProductOptions from './ProductOptions';
import MiniFindMyPartOptionsPsg from './MiniFindMyPartOptionsPsg';
import MiniFindMyPartOptionsGeneral from './MiniFindMyPartOptionsGeneral';
//import { } from './miniFindMyPartFunctions';

const MiniFindMyPartContainer = ({
  baseProductSystemId,
  selectedVariantId,
}) => {
  const miniFindMyPartRef = useRef();
  const [initBrandValue, setBrandValue] = useState({});
  const [initModelValue, setModelValue] = useState({});
  const [initYearValue, setYearValue] = useState({});

  const products = useSelector((state) => state.findMyPart.products);
  const searchItems = useSelector((state) => state.findMyPart.searchItems);
  const options = useSelector((state) => state.findMyPart.options);
  const dispatch = useDispatch();
  const [activeSegment, setActiveSegment] = useState(null);
  const [mounted, setMounted] = useState(false);
  const [psgSearchItems, setPsgSearchItems] = useState(false);

  const toggleSegment = (segment) => {
    let newFilterList = [];
    setActiveSegment(segment);
  };
  useEffect(() => {
    async function setup() {
      const urlParams = new URLSearchParams(window.location.search);

      // Intentional only having value
      const urlBrand = { value: urlParams.get('brand') };
      setBrandValue(urlBrand);
      const urlModel = { value: urlParams.get('model') };
      setModelValue(urlModel);
      const urlYear = { value: urlParams.get('year') };
      setYearValue(urlYear);
      const options = {
        baseProductSystemId,
        selectedVariantId,
        segment: null,
        optionsGeneral: {
          brand: urlBrand,
          model: urlModel,
          year: urlYear,
        },
        optionsPsg: null,
      };
      dispatch(getOptions(options, false, true));
      if (!mounted) {
        setMounted(true);
      }
    }
    setup();
  }, []);

  useEffect(() => {
    //dispatch(getSegments());
  }, [dispatch]);

  useEffect(() => {
    if (mounted) {
      setFilters();
    }
  }, [products]);

  useEffect(() => {
    if (searchItems?.length > 0) {
      setPsgSearchItems(
        new Fuse(searchItems, {
          keys: ['brand', 'model', 'year'],
          threshold: 0.3,
          distance: 10,
        })
      );
    }
  }, [searchItems]);
  if (!options) {
    return null;
  }
  return (
    <Fragment>
      <div className="row find-my-part__form-wrapper">
        <div className="small-12 medium-12 columns">
          {options && options.optionsPsg ? (
            <MiniFindMyPartOptionsPsg
              {...{ baseProductSystemId, selectedVariantId, psgSearchItems }}
            />
          ) : (
            <MiniFindMyPartOptionsGeneral
              {...{
                baseProductSystemId,
                initBrandValue,
                initModelValue,
                initYearValue,
                selectedVariantId,
              }}
            />
          )}
          <ProductOptions />
        </div>
      </div>
    </Fragment>
  );
};
export default React.memo(MiniFindMyPartContainer);
